import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class CreditDetailsService {

  constructor(private http: HttpClient) { }

  getModalData(
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {},
    ssoId: string = ''
  ): Observable<any> {
    let params = filterParams;
    params.sso_id = ssoId || globalService?.sso_id || '';
    params.filing_key = filterParams.filing_key || rowData.CONSOL_GROUP_KEY;
    params.ho_le_key = filterParams.ho_le_key || rowData.HO_LE_KEY;
    params.jcd_key = 250;
    params.scenario = filterParams?.scenario || globalService?.scenario || '';
    params.screen_key = globalService?.screen_key || '';
    params.tax_year = rowData.TAX_YEAR;

    const url = baseUrl + "/loadJsonObject?action_code=207vw4";
    
    return this.http.get<any>(url, { 
      params: params,
      withCredentials: true 
    });
  }

  saveModal(
    baseUrl: string,
    finalData: any[],
    clobSettings: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // Build payload EXACTLY like original AngularJS
    let clob_setting = JSON.stringify(clobSettings);
    let clob_data = JSON.stringify(finalData);
  

        // Build checkLockedbj from real rowData
        const checkLockedbj = [{
          leid: rowData?.LEID || rowData?.SOURCE_LEID,
          cdr_number: rowData?.CDR_NO || rowData?.TAX_CODE,
          reporting_period: String(rowData?.REPORTING_PERIOD || ''),
          combination_key: String(rowData?.COMBINATION_KEY || ''),
          scenario_key: parseInt(filterParams?.scenario || 0)
        }];
    
    let params = filterParams;
    params = _.merge({}, globalService || {}, params);
    params = _.extend({clob_data: clob_data}, params);
    params = _.extend({clob_setting: clob_setting}, params);
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    params.is_issue_key_enabled = 'N';
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.process_name = "credits-adjustment-save";

    // 🔴 MUST use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = baseUrl + "/saveJsonObject?action_code=t652fd";
    
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
